import { createBrowserHistory } from "history";

// Docs: https://github.com/remix-run/history/blob/main/docs/api-reference.md
const history = createBrowserHistory();

export default history;
